import React from 'react'
import { dotNetCoreWizardStepsNormalizeAgentDownload } from './steps-dotnet-core'
import { dotnetWizardStepsNormalizeAgentDownload } from './steps-dotnet'
import { goWizardStepsNormalizeAgentDownload } from './steps-go'
import { javaWizardStepsNormalizeAgentDownload } from './steps-java'
import { nodeWizardStepsNormalizeAgentDownload } from './steps-node'
import { phpWizardStepsNormalizeAgentDownload } from './steps-php'
import { pythonWizardStepsNormalizeAgentDownload } from './steps-python'
import { rubyWizardStepsNormalizeAgentDownload } from './steps-ruby'
import { universalWizardStepsNormalizeAgentDownload } from './steps-universal'
import { SplitContext } from '../../../../../ng/splitio-wrapper'

export { onboardViaDocsAgentWizardSteps } from './onboardviadocs'
export const stepMappingNormalizeAgentDownload = {
  DOTNET: dotnetWizardStepsNormalizeAgentDownload,
  DOTNET_CORE: dotNetCoreWizardStepsNormalizeAgentDownload,
  GO: goWizardStepsNormalizeAgentDownload,
  JAVA: javaWizardStepsNormalizeAgentDownload,
  NODE: nodeWizardStepsNormalizeAgentDownload,
  PHP: phpWizardStepsNormalizeAgentDownload,
  PYTHON: pythonWizardStepsNormalizeAgentDownload,
  RUBY: rubyWizardStepsNormalizeAgentDownload
}

export const useAgentWizardSteps = () => {
  const universalAgentFlow =
    // true ||
    React.useContext(SplitContext).isSplitTreatmentOn(
      'TS-39140_agent_manager_wizard'
    )
      ? { UNIVERSAL: universalWizardStepsNormalizeAgentDownload }
      : {}

  return {
    ...stepMappingNormalizeAgentDownload,
    ...universalAgentFlow
  }
}
